module.exports = __webpack_public_path__ + "img/1564698440.6565d271.jpg";